import React from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

export function FloatingCart() {
    const { count } = useCart();
    if (count === 0) return null;
    // Only shown on mobile; desktop cart lives in the top nav
    return (
        <Link
            to="/checkout"
            data-testid="floating-cart-btn"
            className="md:hidden fixed bottom-24 right-4 z-40 bg-primary text-primary-foreground rounded-full p-4 shadow-warm hover:scale-105 transition-transform active:scale-95 flex items-center justify-center"
            aria-label="View cart"
        >
            <ShoppingBag className="h-5 w-5" strokeWidth={1.75} />
            <span
                data-testid="cart-count-badge"
                className="absolute -top-1 -right-1 min-w-[1.25rem] h-5 rounded-full bg-foreground text-background text-[10px] font-bold flex items-center justify-center px-1"
            >
                {count}
            </span>
        </Link>
    );
}
